"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentSchedulerCms = void 0;
var AppointmentSchedulerCms = /** @class */ (function () {
    function AppointmentSchedulerCms() {
        this.weekDaysDropdownOptions = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        this.timeSlotsDropdownOptions = ['8 a.m. to 12 p.m.', '12 p.m. to 2 p.m.', '2 p.m. to 4 p.m.'];
        this.appointmentDaySelectionLabel = 'Day of the week';
        this.mockInputBoxLabel = 'xxx';
        this.appointmentTimeSelectionLabel = 'Technician\'s arrival window';
        this.appointmentTimeSelectionToolTip = "Your technician's arrival time is flexible.\n\n    The time ranges listed reflect the technician's arrival window and not the length of the installation.\n    Depending on services ordered, a standard installation takes an average of 4 hours from the time your\n    technician arrives";
    }
    return AppointmentSchedulerCms;
}());
exports.AppointmentSchedulerCms = AppointmentSchedulerCms;
//# sourceMappingURL=AppointmentScheduler.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/AppointmentScheduler/AppointmentScheduler.cms.js
// module id = 957
// module chunks = 8